import { useMutation, useQueryClient } from 'react-query';

import { actionTemplatesApi } from 'config/api/actionLibrary/actionLibrary';

const useLockActionTemplate = () => {
  const queryClient = useQueryClient();

  return useMutation((id: number) => actionTemplatesApi.lockActionTemplate(id), {
    onSuccess: (_, id) => {
      queryClient.invalidateQueries(['actionTemplate', id.toString()]);
      queryClient.invalidateQueries(['actionTemplates']);
    },
  });
};

export default useLockActionTemplate;
